var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneTimeLottery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 149,
    viewBox: "0 0 257 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1020_2817)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -26.5,
    y: -17.5,
    width: 304,
    height: 226,
    rx: 11.5,
    stroke: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1020_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.765 45.6935H152.148L126 49.4761L99.851 45.6935H96.856C93.6269 45.6935 91.0093 43.0758 91.0093 39.8467C91.0091 36.6176 93.6269 34 96.856 34H154.765C157.994 34 160.612 36.6176 160.612 39.8467C160.612 43.0758 157.994 45.6935 154.765 45.6935Z",
    fill: "#B98080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.144 34H149.47C152.699 34 155.316 36.6176 155.316 39.8467C155.316 43.0758 152.699 45.6935 149.47 45.6935H155.144C158.373 45.6935 160.99 43.0758 160.99 39.8467C160.991 36.6176 158.373 34 155.144 34Z",
    fill: "#AE6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.77 53.0332V45.6935H99.8511V53.0332C99.8511 64.4191 107.129 74.104 117.286 77.693C118.688 78.1883 119.625 79.5132 119.625 80.9998C119.625 82.4866 118.688 83.8115 117.286 84.3066C107.129 87.8957 99.8511 97.5805 99.8511 108.966V116.306H151.77V108.966C151.77 97.5805 144.492 87.8957 134.335 84.3066C132.933 83.8113 131.996 82.4864 131.996 80.9998H132.374C132.374 79.513 132.933 78.1883 134.335 77.693C144.492 74.1041 151.77 64.4191 151.77 53.0332Z",
    fill: "#EFEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8511 45.6935V49.4003H142.841C144.848 49.4003 146.474 51.0269 146.474 53.0332C146.474 64.3838 139.242 74.0438 129.134 77.6593C127.884 78.1066 126.927 79.1743 126.737 80.4888C126.494 82.1755 127.479 83.7551 129.04 84.3066C139.197 87.8957 146.474 97.5807 146.474 108.966V116.306H152.148V108.966C152.148 97.6159 144.916 87.9558 134.808 84.3403C133.558 83.893 132.601 82.8253 132.411 81.5109C132.168 79.8242 133.153 78.2445 134.714 77.693C144.871 74.104 152.148 64.4189 152.148 53.0332V49.4005V45.6935H99.8511Z",
    fill: "#D7D0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.765 128H96.856C93.6269 128 91.0093 125.382 91.0093 122.153C91.0093 118.924 93.6269 116.307 96.856 116.307H99.8513L126 112.524L152.149 116.307H154.766C157.995 116.307 160.612 118.924 160.612 122.153C160.612 125.382 157.994 128 154.765 128Z",
    fill: "#B98080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.144 116.307H149.47C152.699 116.307 155.316 118.924 155.316 122.153C155.316 125.382 152.699 128 149.47 128H155.144C158.373 128 160.99 125.382 160.99 122.153C160.991 118.924 158.373 116.307 155.144 116.307Z",
    fill: "#AE6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.592 95.7936H135.838C133.068 95.7936 130.327 93.79 129.874 91.058L128.75 84.2807C128.178 80.8313 130.839 77.6932 134.336 77.6932C141.121 75.2957 146.617 70.1754 149.521 63.6474H102.101C105.005 70.1756 110.501 75.2957 117.286 77.6932C120.783 77.6932 123.443 80.8313 122.871 84.2807L121.748 91.058C121.295 93.79 118.932 95.7936 116.162 95.7936H113.03C105.81 95.7936 99.8909 101.603 99.8519 108.823C99.8518 108.871 99.8516 108.919 99.8516 108.967V116.307H151.77V108.967C151.77 108.919 151.77 108.871 151.77 108.823C151.731 101.603 145.812 95.7936 138.592 95.7936Z",
    fill: "#FED402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.148 108.823C152.109 101.603 146.19 95.7936 138.97 95.7936H135.838C133.068 95.7936 130.705 93.79 130.252 91.058L129.129 84.2807C128.557 80.8313 131.217 77.6932 134.714 77.6932C141.499 75.2957 146.995 70.1754 149.899 63.6474H144.225C141.321 70.1756 135.825 75.2957 129.04 77.6932C125.543 77.6932 122.883 80.8313 123.455 84.2807L124.578 91.058C125.031 93.79 127.394 95.7936 130.164 95.7936H133.296C140.516 95.7936 146.435 101.603 146.474 108.823C146.474 108.871 146.475 108.919 146.475 108.967V116.307H152.149V108.967C152.149 108.919 152.148 108.871 152.148 108.823Z",
    fill: "#FAC600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1020_2817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white",
    transform: "translate(82 28)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1020_2817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white",
    transform: "translate(79 34)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneTimeLottery);
export default __webpack_public_path__ + "static/media/oneTimeLottery.25a6457d22cdf80fa20f08ee66ce656a.svg";
export { ForwardRef as ReactComponent };